export default {"src":"/_next/static/media/mural-grid-transfer.38b80cd6.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};